import { render, staticRenderFns } from "./DiscountPopup.vue?vue&type=template&id=10b1919a&"
import script from "./DiscountPopup.vue?vue&type=script&lang=js&"
export * from "./DiscountPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports